module dg.files {
    angular.module('dg.files', ['flow'])
        //.config(['flowFactoryProvider', function (flowFactoryProvider) {

        //    flowFactoryProvider.defaults = {
        //        target: '/upload',
        //        permanentErrors: [404, 500, 501]
        //    };
        //    // You can also set default events:
        //    flowFactoryProvider.on('catchAll', function (event) {
        //        console.log(event);
        //    });
        //    // Can be used with different implementations of Flow.js
        //    // flowFactoryProvider.factory = fustyFlowFactory;
        //}]);
}